module.exports = __webpack_public_path__ + "5de2424ca3a7bc526b217c2c0b2a3ffb.png";